import { Component, computed, HostListener, inject, signal } from '@angular/core';
import { TherapistClientStateService } from '@therapist/shared/services/state/therapist-client-state.service';
import { TableModule } from 'primeng/table';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { Tag } from 'primeng/tag';
import { ExerciseActivityTypeEnum } from '@therapist/shared/models/exercise/exercise-template.dto';
import { Badge } from 'primeng/badge';
import { toObservable } from '@angular/core/rxjs-interop';
import { WithMobileDetection } from '@base/mixins/with-mobile-detection.mixin';

@Component({
  selector: 'sana-tp-client-list',
  imports: [
    TableModule,
    DatePipe,
    Tag,
    Badge
  ],
  templateUrl: './client-list.component.html',
  styleUrl: './client-list.component.scss'
})
export class ClientListComponent extends WithMobileDetection() {

  readonly #clientStateService = inject(TherapistClientStateService);
  readonly #router = inject(Router);

  readonly clientList = this.#clientStateService.getClientList();
  readonly activeClientFilter = signal<ClientFilterType | null>(null);

  readonly filteredClientList = computed(() => {
    const filter = this.activeClientFilter();

    if (filter === ClientFilterType.ActiveClients) {
      return this.clientList().filter(client => client.hasActiveTherapyPlan);
    }

    if (filter === ClientFilterType.InactiveClients) {
      return this.clientList().filter(client => !client.hasActiveTherapyPlan);
    }

    return this.clientList();
  });

  @HostListener('window:resize', ['$event'])
  private onWindowResize($event: Event) {
    window.setTimeout(() => this.setTableWrapperSize(), 100);
  }

  constructor() {
    super();

    toObservable(this.clientList)
      .subscribe(clientList => {
        window.setTimeout(() => this.setTableWrapperSize(), 100);
      });
  }

  setTableWrapperSize(): void {
    const tableWrapper = document.getElementById('table-wrapper');
    if (!tableWrapper) {
      return;
    }

    const distanceToDocumentTop = tableWrapper!.getBoundingClientRect().top + window.scrollY;
    let distanceToViewportBottom = window.innerHeight - distanceToDocumentTop - 42;
    let documentWidth = window.innerWidth - 64 - 280;

    if (this.isMobile()) {
      // extra space for bottom bar
      distanceToViewportBottom -= 60;

      // no sidebar anymore
      documentWidth += 280;
    }

    const table = document.getElementById('table');
    // tableWrapper!.style.height = `${table!.offsetHeight}px`;
    // tableWrapper!.style.maxHeight = `${distanceToViewportBottom}px`;
    tableWrapper!.style.height = `${distanceToViewportBottom}px`;
    tableWrapper!.style.width = `${documentWidth}px`;
  }

  routeToClientDetails(id: string): void {
    this.#router.navigate([`/client/${id}`]);
  }

  clientFilterClicked(clientFilter: ClientFilterType): void {
    if (this.activeClientFilter() === clientFilter) {
      this.activeClientFilter.set(null);
      return;
    }

    this.activeClientFilter.set(clientFilter);
  }

  protected readonly ExerciseActivityTypeEnum = ExerciseActivityTypeEnum;
  protected readonly ClientFilterType = ClientFilterType;
}

export enum ClientFilterType {
  ActiveClients,
  InactiveClients
}
